export const FINISHED_GETTING_PATIENT_INFO = 'FINISHED_GETTING_PATIENT_INFO';
export type FINISHED_GETTING_PATIENT_INFO = typeof FINISHED_GETTING_PATIENT_INFO;

export const FINISHED_CONFIRMING_POSTAL_CODE = 'FINISHED_CONFIRMING_POSTAL_CODE';
export type FINISHED_CONFIRMING_POSTAL_CODE = typeof FINISHED_CONFIRMING_POSTAL_CODE;

export const RETURN_TO_INTRODUCTION_SCREEN = 'RETURN_TO_INTRODUCTION_SCREEN';
export type RETURN_TO_INTRODUCTION_SCREEN = typeof RETURN_TO_INTRODUCTION_SCREEN;

export const START_APPLICATION_AFTER_SETTING_UP_ADMIN_OPTIONS = 'START_APPLICATION_AFTER_SETTING_UP_ADMIN_OPTIONS';
export type START_APPLICATION_AFTER_SETTING_UP_ADMIN_OPTIONS = typeof START_APPLICATION_AFTER_SETTING_UP_ADMIN_OPTIONS;

export const CANCEL_POSTAL_CODE_CONFIRMATION = 'CANCEL_POSTAL_CODE_CONFIRMATION';
export type CANCEL_POSTAL_CODE_CONFIRMATION = typeof CANCEL_POSTAL_CODE_CONFIRMATION;

export const SUBMIT_HEALTH_CARD_NUMBER_TO_SERVER = 'SUBMIT_HEALTH_CARD_NUMBER_TO_SERVER';
export type SUBMIT_HEALTH_CARD_NUMBER_TO_SERVER = typeof SUBMIT_HEALTH_CARD_NUMBER_TO_SERVER;


// WEBPACK FOOTER //
// ./src/sagas/ApplicationAsyncSagas/constant.ts